export const web3Colors = {
  background: '#02000a',
  purple: '#7D6CFF',
  purpleLight: '#A79DF5',
  grey: '#b6b3bd',
  blue: '#6380d6',
  darkPurple: '#0b0042',
};
